module.exports = __webpack_public_path__ + "media/src/assets/Images/Deanda-2e93cff38fc62d1aeaffe60d3948ca2d.svg";